module.exports = "<dt-chart class=chart ng-class=\"{\n            'chart-proximity-preview': $ctrl.chartType === 'proximity',\n            'chart-touch-preview': $ctrl.chartType === 'touch',\n            'chart-temperature-preview': $ctrl.chartType === 'temperature'\n        }\" config=$ctrl.chartConfig></dt-chart> <div layout=row layout-align=\"end center\"> <a ui-sref=main.sensors.list.thing.graph class=\"md-primary md-caption\">See more detailed graph</a> </div> ";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/thing-details/details-chart/details-chart.html
// module id = 8tMW
// module chunks = 1